import { FC } from 'react';
import { Box, Typography } from '@mui/material';

interface SectionHeaderProps {
  label: string;
  count?: number;
  actionLabel?: string;
  onAction?: () => void;
  isActionDisabled?: boolean;
}

const SectionHeader: FC<SectionHeaderProps> = ({
  label,
  count,
  actionLabel,
  onAction,
  isActionDisabled = false,
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      mb: 0.5,
    }}
  >
    <Typography fontSize={14} fontWeight={700} sx={{ color: '#162936' }}>
      {count !== undefined ? `${label} (${count})` : label}
    </Typography>
    {actionLabel && (
      <Typography
        fontSize={14}
        fontWeight={700}
        onClick={isActionDisabled ? undefined : onAction}
        sx={{
          color: isActionDisabled ? '#989CA2' : '#51B8B0',
          cursor: isActionDisabled ? 'not-allowed' : 'pointer',
          userSelect: 'none',
        }}
      >
        {actionLabel}
      </Typography>
    )}
  </Box>
);

export default SectionHeader;
